module.exports = __webpack_public_path__ + "static/assets/6970e9fd55156745225b91ea3fce3682.svg";